import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthProviderCard, FormField } from '../components';
export function GoogleOAuthSection({ enabled, clientId, clientSecret, onToggle, onClientIdChange, onClientSecretChange }) {
    return /*#__PURE__*/ _jsxs(AuthProviderCard, {
        title: "Google OAuth",
        description: "Sign in with Google",
        enabled: enabled,
        onToggle: onToggle,
        children: [
            /*#__PURE__*/ _jsx(FormField, {
                id: "google-client-id",
                label: "Google Client ID",
                value: clientId,
                onChange: onClientIdChange,
                placeholder: "123456789-abcdefg.apps.googleusercontent.com",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "google-client-secret",
                label: "Google Client Secret",
                value: clientSecret,
                onChange: onClientSecretChange,
                type: "password",
                placeholder: "Enter to update, leave blank to keep existing",
                helpText: "For security, secrets are not displayed. Enter a new value to update.",
                required: true
            })
        ]
    });
}
